(() => {
  if (window.__LDJ_CART_DRAWER_LOADED__) return;
  window.__LDJ_CART_DRAWER_LOADED__ = true;

  const root = document.querySelector('[data-cart-drawer-root]');

  if (!root) return;

  const drawer = root.querySelector('.ldj-cart__drawer');
  const itemsContainer = root.querySelector('[data-cart-items]');
  const footer = root.querySelector('[data-cart-footer]');
  const subtotal = root.querySelector('[data-cart-subtotal]');
  const closeButtons = root.querySelectorAll('[data-cart-close]');

  const shopRoot =
    window.Shopify?.routes?.root || '/';

  const escapeHtml = (value = '') => {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  };

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency
        }
      ).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const updateBagCount = (count) => {
    document.querySelectorAll('.ldj-header__bag').forEach((bag) => {
      bag.textContent =
        count > 0
          ? `BAG (${count})`
          : 'BAG';
    });
  };

  const renderCart = (cart) => {
    updateBagCount(cart.item_count);

    if (!cart.items.length) {
      itemsContainer.innerHTML = `
        <p class="ldj-cart__empty">
          Your bag is empty.
        </p>
      `;

      footer.hidden = true;
      return;
    }

    const items = cart.items.map((item) => {
      const image =
        item.featured_image?.url || item.image || '';

      const imageAlt =
        item.featured_image?.alt ||
        item.product_title ||
        '';

      const variantTitle =
        item.variant_title &&
        item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';

      return `
        <article class="ldj-cart-item">
          ${
            image
              ? `
                <a
                  href="${escapeHtml(item.url)}"
                  class="ldj-cart-item__image-wrap"
                >
                  <img
                    src="${escapeHtml(image)}"
                    alt="${escapeHtml(imageAlt)}"
                    class="ldj-cart-item__image"
                    loading="lazy"
                  >
                </a>
              `
              : `
                <div class="ldj-cart-item__image-wrap"></div>
              `
          }

          <div class="ldj-cart-item__content">

            <div>
              <a
                href="${escapeHtml(item.url)}"
                class="ldj-cart-item__title"
              >
                ${escapeHtml(item.product_title)}
              </a>

              ${
                variantTitle
                  ? `
                    <p class="ldj-cart-item__variant">
                      ${escapeHtml(variantTitle)}
                    </p>
                  `
                  : ''
              }
            </div>

            <div class="ldj-cart-item__bottom">

              <div class="ldj-cart-item__quantity">
                <button
                  type="button"
                  class="ldj-cart-item__quantity-button"
                  data-cart-change
                  data-cart-key="${escapeHtml(item.key)}"
                  data-cart-quantity="${item.quantity - 1}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <span class="ldj-cart-item__quantity-value">
                  ${item.quantity}
                </span>

                <button
                  type="button"
                  class="ldj-cart-item__quantity-button"
                  data-cart-change
                  data-cart-key="${escapeHtml(item.key)}"
                  data-cart-quantity="${item.quantity + 1}"
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              <span class="ldj-cart-item__price">
                ${formatMoney(item.final_price, cart.currency)}
              </span>

            </div>

          </div>
        </article>
      `;
    }).join('');

    itemsContainer.innerHTML = `
      <div class="ldj-cart__items">
        ${items}
      </div>
    `;

    subtotal.textContent =
      formatMoney(cart.items_subtotal_price, cart.currency);

    footer.hidden = false;
  };

  const getCart = async () => {
    const response = await fetch(
      `${shopRoot}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    const cart = await response.json();

    renderCart(cart);

    return cart;
  };

  const openCart = async () => {
    try {
      await getCart();
    } catch {
      return;
    }

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('ldj-cart-open');

    window.requestAnimationFrame(() => {
      root.querySelector('.ldj-cart__close')?.focus();
    });
  };

  const closeCart = () => {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('ldj-cart-open');
  };

  const changeQuantity = async (key, quantity) => {
    itemsContainer.style.pointerEvents = 'none';
    itemsContainer.style.opacity = '0.6';

    try {
      const response = await fetch(
        `${shopRoot}cart/change.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity
          })
        }
      );

      if (!response.ok) {
        throw new Error('Unable to update cart');
      }

      const cart = await response.json();

      renderCart(cart);
    } finally {
      itemsContainer.style.pointerEvents = '';
      itemsContainer.style.opacity = '';
    }
  };

  document.addEventListener('click', (event) => {
    const openTrigger =
      event.target.closest('[data-cart-open]');

    if (openTrigger) {
      event.preventDefault();
      openCart();
      return;
    }

    const changeTrigger =
      event.target.closest('[data-cart-change]');

    if (changeTrigger) {
      const key = changeTrigger.dataset.cartKey;
      const quantity =
        Number(changeTrigger.dataset.cartQuantity);

      changeQuantity(key, quantity);
    }
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeCart);
  });

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      root.classList.contains('is-open')
    ) {
      closeCart();
    }
  });

  document.addEventListener('ldj:cart-updated', (event) => {
    if (event.detail) {
      renderCart(event.detail);
    }

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('ldj-cart-open');
  });

  window.LDJCart = {
    open: openCart,
    close: closeCart,
    refresh: getCart
  };
})();
